import React from 'react';

const LoadingSpinner = () => (
    <div>
        <i className="fa fa-spinner fa-spin" /> Loading...
        {/* <i class="fa fa-spinner fa-pulse fa-3x fa-fw" /> */}
    </div>
);

export default LoadingSpinner;